import { LmsHttpHelper, NO_DATA_MESSAGE } from '../../utils/HttpHelper';

const PutLmsUserAccountData = (lmsUserAccountId, courseEnrollmentObj, state, setState) => {
  if (state.isSaving !== true && !state.message) {
    let newState = {
      ...state,
      isSaving: true,
      isSaved: false,
      message: 'Saving...'
    };
    setState(newState);

    const lmsUserAccountIdForUrl = lmsUserAccountId ? encodeURIComponent(lmsUserAccountId) : 'NaN';
    const url = `/User/${lmsUserAccountIdForUrl}`;
    LmsHttpHelper(url, 'PUT', courseEnrollmentObj)
      .then((objData) => {
        if (!objData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          newState = {
            ...newState,
            isObjLoaded: true,
            isSaving: false,
            isSaved: true,
            objData,
            message: ''
          };
          setState(newState);
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isObjLoaded: false,
          isSaving: false,
          isSaved: false,
          message: message
        });
      });
  }
};

export default PutLmsUserAccountData;